export default (enummeration: any): any[] => Object.values(enummeration)
